package us.laantech.common.api

import kotlinx.serialization.Serializable

@Serializable
data class OAuth2TokenResponse(
    val access_token: String,
    val id_token: String,
    val refresh_token: String? = null,
    val token_type: String,
    val expires_in: Int,
) {
    fun toAuthResult(): AuthResult = AuthResult(
        AccessToken = access_token,
        IdToken = id_token,
        RefreshToken = refresh_token,
        TokenType = token_type,
        ExpiresIn = expires_in,
    )
}
